import ExitPickTour from './ExitPickTour';

export default ExitPickTour;
